import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';

export const usePaymentIntent = () => {
  const { paymentMethodDetailEntities, checkoutSessionEntity, update } = useCheckoutSessionContext();

  const createPaymentIntent = async (paymentMethodDetailEntity: PaymentMethodDetailEntity) => {
    if (!checkoutSessionEntity) {
      throw new Error('Checkout session entity not found');
    }

    if (paymentMethodDetailEntity.shouldCreatePaymentIntentBesidesExternalProvider() === false) {
      throw new Error('Payment method detail entity should not create payment intent');
    }

    const clientSecret = await checkoutSessionEntity.getClientSecret();
    await paymentMethodDetailEntity.createPaymentIntent(clientSecret);
  };

  const refreshPaymentMethodEntity = async (paymentMethodDetailEntity: PaymentMethodDetailEntity) => {
    update({ refreshing: true });
    try {
      const refreshedEntity = await paymentMethodDetailEntity.refresh();
      updatePaymentMethodEntity(refreshedEntity);
    } finally {
      update({ refreshing: false });
    }
  };

  const updatePaymentMethodEntity = (paymentMethodDetailEntity: PaymentMethodDetailEntity) => {
    update({
      paymentMethodDetailEntities: [...paymentMethodDetailEntities].map((entity) => {
        if (entity.type === paymentMethodDetailEntity.type) {
          // Force re-render by creating a new instance
          return paymentMethodDetailEntity.clone();
        }
        return entity;
      }),
    });
  };

  return {
    createPaymentIntent,
    refreshPaymentMethodEntity,
    updatePaymentMethodEntity,
  };
};
